const TermsOfUseTranslations = {
  'en-US': {
    termsOfUse: {
      pageTitle: 'Terms of Use',
      hero: {
        title1: 'Terms of',
        title2: 'Use',
        desc: 'These Terms of Use govern your access to and use of aitrade.ai. By accessing or using our website and services, you agree to comply with these terms. Please read them carefully before engaging with our platform.',
        desc2:
          'Your continued use of aitrade.ai constitutes your acceptance of these Terms and your agreement to abide by them.',
      },
      sections: {
        intro: {
          title: 'Introduction',
          content:
            'Welcome to aitrade.ai. These Terms of Use ("Terms") set forth the legally binding terms and conditions that govern your use of our website, platform, and services (collectively, the "Services"). By accessing or using our Services, you agree to be bound by these Terms, as well as any additional terms or policies referenced herein, including but not limited to our Privacy Policy. If you do not agree to these Terms, you must refrain from using our Services. We reserve the right to update or modify these Terms at any time without prior notice. Your continued use of the Services after any such changes constitutes your acceptance of the revised Terms.',
        },
        eligibility: {
          title: 'Eligibility',
          content:
            'By using aitrade.ai, you represent and warrant that you are at least 18 years old or the age of majority in your jurisdiction, whichever is greater. You also confirm that you are legally capable of entering into binding agreements. If you are using the Services on behalf of an organization or entity, you represent that you have the authority to bind that organization or entity to these Terms. Use of our Services is prohibited in jurisdictions where it would violate applicable laws or regulations.',
        },
        account: {
          title: 'Account Responsibilities',
          content:
            'To access certain features of our Services, you may be required to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities conducted under your account. You agree to provide accurate, current, and complete information during registration and to update such information as necessary. If you suspect unauthorized access to your account, you must notify us immediately at office@aitrade.ai. We are not liable for any loss or damage arising from your failure to comply with these obligations.',
        },
        prohibited: {
          title: 'Prohibited Activities',
          content:
            'You agree not to engage in any activities that could harm aitrade.ai, its users, or its operations. Prohibited activities include but are not limited to:\n' +
            '- Attempting to gain unauthorized access to our systems or data.\n' +
            '- Using automated tools such as bots or scrapers without authorization.\n' +
            '- Introducing malware, viruses, or other harmful code.\n' +
            '- Engaging in fraudulent activities or misrepresenting your identity.\n' +
            '- Violating any applicable laws or regulations.\n' +
            '- Infringing on the intellectual property rights of aitrade.ai or third parties.\n' +
            'We reserve the right to investigate and take appropriate legal action against anyone who violates these rules.',
        },
        intellectual: {
          title: 'Intellectual Property',
          content:
            'All content on aitrade.ai, including but not limited to text, graphics, logos, images, software, and other materials ("Content"), is owned by aitrade.ai or its licensors and is protected by copyright, trademark, and other intellectual property laws. You may not copy, reproduce, distribute, modify, create derivative works from, publicly display, perform, republish, download, store, or transmit any Content without prior written consent from us. Unauthorized use of our intellectual property may result in legal action.',
        },
        termination: {
          title: 'Termination',
          content:
            'We reserve the right to suspend or terminate your access to the Services at any time for any reason, including but not limited to violations of these Terms. Upon termination:\n' +
            '- Your right to access and use the Services will cease immediately.\n' +
            '- We may delete your account and associated data without liability.\n' +
            '- Any provisions of these Terms that by their nature should survive termination (e.g., intellectual property rights) will remain in effect.\n' +
            'If you wish to terminate your account voluntarily, please contact us at office@aitrade.ai.',
        },
        disclaimer: {
          title: 'Disclaimers and Limitations',
          content:
            'The Services are provided "as is" and "as available" without warranties of any kind, either express or implied. We disclaim all warranties related to merchantability, fitness for a particular purpose, non-infringement, and uninterrupted operation. To the fullest extent permitted by law:\n' +
            '- aitrade.ai shall not be liable for indirect, incidental, special, consequential damages arising from your use of the Services.\n' +
            '- This includes but is not limited to loss of profits, data breaches caused by third parties beyond our control, or interruptions in service availability.',
        },
        changes: {
          title: 'Changes to These Terms',
          content:
            'We reserve the right to modify these Terms at any time at our sole discretion. Any changes will be effective immediately upon posting on this page unless otherwise stated. It is your responsibility to review these Terms periodically for updates. Your continued use of the Services after changes are posted constitutes acceptance of those changes.',
        },
        contact: {
          title: 'Contact Us',
          content:
            'If you have questions about these Terms of Use or need assistance with our Services, please contact us at office@aitrade.ai. Our team is available during business hours to address your concerns promptly.',
        },
        privacy: {
          title: 'Privacy Policy',
          content:
            'Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your personal data when you use our Services. By agreeing to these Terms of Use, you also agree to the terms outlined in our Privacy Policy.',
        },
        disputeResolution: {
          title: 'Dispute Resolution',
          content:
            'In the event of a dispute arising from these Terms or your use of the Services:\n' +
            '- You agree first to attempt resolution informally by contacting us at office@aitrade.ai.\n' +
            '- If informal resolution fails within 30 days from initial contact regarding the dispute, it shall be resolved through binding arbitration under jurisdiction.\n' +
            '- You waive your right to participate in class actions against us.',
        },
        governingLaw: {
          title: 'Governing Law',
          content:
            'These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict-of-law principles. Any legal proceedings arising out of these Terms must be brought exclusively in competent courts within the relevant jurisdiction.',
        },
        indemnification: {
          title: 'Indemnification',
          content:
            'You agree to indemnify and hold harmless aitrade.ai and its affiliates from any claims, liabilities, damages (including legal fees) arising out of:\n' +
            '- Your breach of these Terms.\n' +
            '- Your violation of applicable laws.\n' +
            '- Your infringement on third-party rights while using our platform.',
        },
      },
    },
  },
}

export default TermsOfUseTranslations
